/**
 * BRINUTI — LANDING → TERMÉKOLDAL ÁTADÁS (2026-10-31, v3)
 *
 * A landing oldalakról érkező címet (?beliv=<kulcs>&nev=<név>) a Teeinblue-űrlapba írja, hogy
 * a vevő ne kezdje elölről: a lapok (belív) előre ki vannak választva, a név már a mezőben
 * van. Kulcsok: onismereti, hatarido, idopont, pontracsos, vonalas, sima.
 *
 * A MEZŐK FELISMERÉSE a Teeinblue mezőcímkéjéből történik (.tee-field__heading):
 *   „… Írd be a neved!”      → teljes név
 *   „… vezetékneved”         → az első szó (magyar névsorrend)
 *   „… keresztneved”        → a többi szó
 *   „… monogramod”         → kezdőbetűk (pontokkal, ha a mező mintája is pontos: „H.J.”)
 *   minden más (napló címe, kedvenc neve, szöveg) → nem nyúlunk hozzá.
 * Ha egy terméknek csak monogram-mezője van, a kezdőbetűk kerülnek bele.
 *
 * A Teeinblue az űrlapot késve és újra-újra rajzolja (a színváltozó ?valtozat= kijelölése újrarajzolást
 * okoz, és ilyenkor a mezők alaphélyzetbe ugranak), ezért kb. 20 másodpercig folyamatosan
 * ellenőrizzük, és ha egy érték eltűnt, újra beírjuk. Ha a vevő közben maga nyúl az űrlaphoz
 * (billentyű, kattintás, érintés), azonnal abbahagyjuk. A mentett Teeinblue-állapotot (előző
 * látogatás) a cím felülírja. Ha bármi hiányzik, csendben nem csinálunk semmit.
 */
(function () {
  'use strict';
  var p;
  try { p = new URLSearchParams(location.search); } catch (e) { return; }
  var MINTA = {
    onismereti: /önismereti/i,
    hatarido: /határidő/i,
    idopont: /időpont/i,
    pontracsos: /pontrácsos|pontozott/i,
    vonalas: /vonalas/i,
    sima: /^\s*(üres|sima)\b/i
  };
  var minta = MINTA[(p.get('beliv') || '').toLowerCase()] || null;
  var nev = (p.get('nev') || '').replace(/[\u0000-\u001f<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 24);
  /* csillagjegy (L16 jegyválasztó): ?jegy=merleg → a „Válassz csillagjegyet” legördülőben a „Mérleg” */
  var jegy = (p.get('jegy') || '').toLowerCase().replace(/[^a-z]/g, '').slice(0, 12);
  if (!minta && !nev && !jegy) return;

  var tiltva = false;    // a vevő maga nyúlt az űrlaphoz
  var probak = 0;
  var stabil = 0;
  var szavak = nev ? nev.split(' ').filter(Boolean) : [];

  function jelez(n) {
    try { if (window.clarity) window.clarity('event', n); } catch (e) {}
  }

  function ertek(el, v) {
    var proto = el.tagName === 'SELECT' ? HTMLSelectElement.prototype : el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, v);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function belivSelect(urlap) {
    var jel = urlap.querySelector('.tee-field[data-btv="beliv"] select');
    if (jel) return jel;
    var lista = urlap.querySelectorAll('select');
    for (var i = 0; i < lista.length; i++) {
      for (var j = 0; j < lista[i].options.length; j++) {
        if (/önismereti|határidő/i.test(lista[i].options[j].text)) return lista[i];
      }
    }
    return null;
  }

  function opcio(sel) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value && minta.test(sel.options[i].text.replace(/^\s*BRINUTI\s*[-–—]\s*/i, ''))) return sel.options[i];
    }
    return null;
  }

  function ekezetnelkul(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z]/g, '');
  }

  function jegySelect(urlap) {
    var mezok = urlap.querySelectorAll('.tee-field');
    for (var i = 0; i < mezok.length; i++) {
      var cim = ((mezok[i].querySelector('.tee-field__heading') || {}).textContent || '');
      var sel = mezok[i].querySelector('select');
      if (sel && /csillagjegy/i.test(cim)) return sel;
    }
    return null;
  }

  function jegyOpcio(sel) {
    for (var i = 0; i < sel.options.length; i++) {
      if (!sel.options[i].disabled && ekezetnelkul(sel.options[i].text) === jegy) return sel.options[i];
    }
    return null;
  }

  /* Mit írjunk az adott mezőbe (null = nem nyúlunk hozzá). */
  function cel(mezo, inp) {
    var cim = ((mezo.querySelector('.tee-field__heading') || {}).textContent || '').toLowerCase();
    var ph = inp.placeholder || '';
    var kezdobetuk = function () {
      var pontos = ph.indexOf('.') >= 0;
      return szavak.map(function (r) { return r.charAt(0).toUpperCase() + (pontos ? '.' : ''); }).join('');
    };
    if (/monogram/.test(cim)) return kezdobetuk();
    if (/vezetékneved|vezetéknév/.test(cim)) return szavak.length > 1 ? szavak[0] : nev;
    if (/keresztneved|keresztnév/.test(cim)) return szavak.length > 1 ? szavak.slice(1).join(' ') : '';
    /* páros borítók: „Írd be az első nevet!” / „második nevet” / „neveket” (a hero-mező: „Anna & Máté”) */
    var par = nev.split(/\s*(?:&|\+|,|\sés\s)\s*/i).filter(Boolean);
    if (/első nevet/.test(cim)) return par[0] || nev;
    if (/második nevet/.test(cim)) return par.length > 1 ? par[1] : '';
    if (/(^|[\s.])neveket(\W|$)/.test(cim)) return nev;
    if (/(^|[\s.])neved(et)?(\W|$)/.test(cim)) return nev;
    /* páros landing (Anna & Máté): a közös fotós/szöveges borítók címe a két név (Made of Memories, Your Pic Your Quote) */
    if (par.length > 1 && /(^|[\s.])c[ií]m[ée]?t(\W|$)/.test(cim)) return nev;
    return null;
  }

  function alkalmaz() {
    var urlap = document.getElementById('teeFormInputs');
    if (!urlap || tiltva) return;
    var rendben = true;

    if (minta) {
      var sel = belivSelect(urlap);
      var o = sel ? opcio(sel) : null;
      if (o) {
        if (sel.value !== o.value) ertek(sel, o.value);
        if (sel.value !== o.value) rendben = false;
      } else rendben = false;
    }
    if (jegy) {
      var jsel = jegySelect(urlap);
      var jo = jsel ? jegyOpcio(jsel) : null;
      if (jo) {
        if (jsel.value !== jo.value) ertek(jsel, jo.value);
        if (jsel.value !== jo.value) rendben = false;
      } else if (jsel) rendben = false;   /* a terméknek nincs jegy-mezője (pl. nem csillagjegyes borító): nem baj */
    }
    if (nev) {
      var mezok = urlap.querySelectorAll('.tee-field--text, .tee-field--paragraph, .tee-field--textarea');
      var db = 0;
      for (var i = 0; i < mezok.length; i++) {
        var inp = mezok[i].querySelector('input[type="text"], textarea');
        if (!inp) continue;
        var c = cel(mezok[i], inp);
        if (c === null) continue;
        db++;
        if (inp.value.toLowerCase() !== c.toLowerCase()) ertek(inp, c);
        if (inp.value.toLowerCase() !== c.toLowerCase()) rendben = false;
      }
      if (!db) rendben = false;
    }
    stabil = rendben ? stabil + 1 : 0;
    if (stabil === 1) jelez('landing_pdp_elokeszitve');
  }

  function indul() {
    ['keydown', 'pointerdown', 'touchstart'].forEach(function (n) {
      document.addEventListener(n, function (e) {
        var t = e.target;
        if (e.isTrusted && t && t.closest && t.closest('#teeFormInputs')) tiltva = true;
      }, true);
    });
    var ido = setInterval(function () {
      probak++;
      alkalmaz();
      /* kb. 20 mp-ig folyamatosan ellenőrzünk (a színváltó újrarajzolása után is rendben maradjon) */
      if (tiltva || probak > 50) clearInterval(ido);
    }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indul);
  else indul();
})();
